import $ from 'jquery'
import { prepareChessboard, validateDrag, validateDrop, validatePosition } from '../../utils';
import User from '../../classes/user';
import { ACTIVITY_COMPLETION_AUDIO, WRONG_ANSWER_AUDIO, CORRECT_ANSWER_AUDIO } from '../../utils/constants';


/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/
export function dragDropPieces(config) {
  let next = config.next,
    fen = config.fen,
    pieceLimit = config.pieceLimit,
    piecesArray = config.piecesArray ? config.piecesArray : [],
    validatePieces = config.validatePieces ? config.validatePieces : [];

  let afterLoad = function () {
    prepareChessboard(config);
  }

  let onDragStart = function (source, piece, position, orientation) {
    validateDrag(piece, pieceLimit[piece])
  };

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let bubbleConfig = {
      data: `Good Job ${User.user.name}!`,
      position: 'left',
      styleClass: 'xs'
    };    
    
    validatePosition(piecesArray.length, fen, next, bubbleConfig, false, true)
    return validateDrop(piece, pieceLimit[piece], target, validatePieces, true)
  }

  const chessConfig = {
    config: {
      draggable: true,
      dropOffBoard: 'trash',
      sparePieces: true,
      onDrop: onDrop,
      onDragStart: onDragStart,
      pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name dragDropPiecesBlackWhiteSide 
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/
export function dragDropPiecesBlackWhiteSide(config) {
  let next = config.next,
    pieceLimit = config.pieceLimit,
    piecesArray = config.piecesArray ? config.piecesArray : [],
    validatePieces = config.validatePieces ? config.validatePieces : [];

  let afterLoad = function () {
    prepareChessboard(config);

    $("#chessBoard").append(`<div class="cp bK"></div><div class="cp bQ"></div><div class="cp wK"></div><div class="cp wQ"></div>`);
    $(".sparepieces_container img, .piece-417db").css({ 'width': '80px', 'height': '120px' });
  }

  let onDragStart = function (source, piece, position, orientation) {
    validateDrag(piece, pieceLimit[piece])
  };

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    if (validatePieces[piece].filter(f => f === target).length === 0) {
      $(".sparepieces_container img[data-piece = " + piece + "]").css("visibility", "visible");
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
      return 'trash';
    } else {
      $("div." + piece).css("visibility", "visible");
      $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
      if ($(".piece-417db").length >= (12 + piecesArray.length)) {
        $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO);
        setTimeout(function () {
          $(document).trigger('next-config', next);
        }, 2000)
      }
    }
  }

  const chessConfig = {
    config: {
      draggable: true,
      dropOffBoard: 'trash',
      sparePieces: true,
      onDrop: onDrop,
      onDragStart: onDragStart,
      pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_2/assignments.js